var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.length > 1)?_c('div',{staticClass:"flex justify-center"},[_c('v-pagination',{attrs:{"color":"midnightGreen","length":_vm.length,"circle":""},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }